interface CreateLinkOptions {
	base: string;
	pathname: string;
	query?: { [key: string]: string | string[] | number | undefined };
}

export function createLink({ base, pathname, query = {} }: CreateLinkOptions): string {
	Object.keys(query).forEach((key) => {
		pathname = pathname.replace(`[${key}]`, String(query[key]));
	});

	const url = new URL(pathname, base);
	const params = new URLSearchParams(query as Record<string, string>);

	Object.keys(query).forEach((key) => {
		if (pathname.includes(String(query[key]))) {
			params.delete(key);
		}
	});

	url.search = params.toString();

	return url.toString();
}
